import type { Registration } from '@/models'
import { HttpErrorService } from '@/services/HttpError.service'
import { registrationErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'

export class RegistrationService {
  private endpoint = '/users/registration'
  private httpErrorService: HttpErrorService<
    keyof typeof registrationErrorHandbook
  >

  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      registrationErrorHandbook,
      'registration',
    )
  }

  async post(body: Registration) {
    return await this.httpService
      .post<Registration>(this.endpoint, {
        fetchConfig: { body: { ...body } },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }
}
